import { axios, BaseApiUrl,BaseUrl} from '../axios_config';

///费用汇总报表
export const GetFeeFlowSumList = params => {
    return axios.post(`${BaseApiUrl}/CostReport/GetFeeFlowSumList`, { ...params }).then(res => res.data);
};


export const FeeFlowSumExport = `${BaseApiUrl}/CostReport/FeeFlowSumExport`;

export const FeeFlowDetailExport = `${BaseApiUrl}/CostReport/FeeFlowDetailExport`;

